import NumberController from "csi/heading/NumberController";
import declare from "dojo/_base/declare";

const ExposureController = declare(NumberController, {
	/**
	 * @override
	 * Make sure Exposure is not higher than 100 or lower than 0
	 */
	process() {
		this.newValue = Math.min(Math.max(0, this.newValue as number), 100);
		this.inherited(arguments);
	},
});

export = ExposureController;
